import { useTheme } from "@mui/material";

function GooglePlayLogoSvg() {
  const { palette } = useTheme();
  return (
    <svg
      width="132"
      height="36"
      viewBox="0 0 132 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.40165 7.33565C9.14724 7.59568 9 8.00051 9 8.52479V27.2255C9 27.7497 9.14724 28.1546 9.40165 28.4146L9.46445 28.4717L20.1976 17.9967V17.7493L9.46445 7.27435L9.40165 7.33565Z"
        fill="url(#paint0_linear_3752_7131)"
      />
      <path
        d="M23.771 21.4897L20.1973 17.9963V17.749L23.7753 14.2556L23.8555 14.301L28.0928 16.655C29.3021 17.323 29.3021 18.4223 28.0928 19.0946L23.8555 21.4443L23.771 21.4897Z"
        fill="url(#paint1_linear_3752_7131)"
      />
      <path
        d="M23.856 21.4449L20.1978 17.8733L9.40186 28.4149C9.80351 28.8271 10.4585 28.8768 11.2033 28.4645L23.856 21.4449Z"
        fill="url(#paint2_linear_3752_7131)"
      />
      <path
        d="M23.856 14.3014L11.2033 7.28178C10.4585 6.87378 9.80351 6.92346 9.40186 7.33569L20.1978 17.873L23.856 14.3014Z"
        fill="url(#paint3_linear_3752_7131)"
      />
      <path
        d="M67.0712 17.1713C64.8112 17.1713 62.9649 18.8506 62.9649 21.1675C62.9649 23.4656 64.8112 25.1625 67.0712 25.1625C69.336 25.1625 71.1822 23.4656 71.1822 21.1675C71.1822 18.8506 69.336 17.1713 67.0712 17.1713ZM67.0712 23.5889C65.8311 23.5889 64.7643 22.5896 64.7643 21.1675C64.7643 19.7266 65.8311 18.7449 67.0712 18.7449C68.3112 18.7449 69.3829 19.7266 69.3829 21.1675C69.3829 22.5896 68.3112 23.5889 67.0712 23.5889ZM58.1118 17.1713C55.8469 17.1713 54.0055 18.8506 54.0055 21.1675C54.0055 23.4656 55.8469 25.1625 58.1118 25.1625C60.3754 25.1625 62.218 23.4656 62.218 21.1675C62.218 18.8506 60.3754 17.1713 58.1118 17.1713ZM58.1118 23.5889C56.8705 23.5889 55.8 22.5896 55.8 21.1675C55.8 19.7266 56.8705 18.7449 58.1118 18.7449C59.3518 18.7449 60.4187 19.7266 60.4187 21.1675C60.4187 22.5896 59.3518 23.5889 58.1118 23.5889ZM47.4504 18.3961V20.0941H51.6036C51.4821 21.043 51.1574 21.7405 50.6594 22.2267C50.0532 22.8139 49.1091 23.4656 47.4504 23.4656C44.8946 23.4656 42.8932 21.4517 42.8932 18.9562C42.8932 16.4608 44.8946 14.4469 47.4504 14.4469C48.8324 14.4469 49.8379 14.9742 50.58 15.6576L51.8057 14.461C50.7677 13.4933 49.3869 12.75 47.4504 12.75C43.9456 12.75 41 15.5343 41 18.9562C41 22.3782 43.9456 25.1625 47.4504 25.1625C49.3448 25.1625 50.7677 24.5565 51.8862 23.4198C53.0325 22.3007 53.3897 20.7271 53.3897 19.4565C53.3897 19.0619 53.356 18.6991 53.2959 18.3961H47.4504ZM91.0459 19.7125C90.7079 18.8188 89.6651 17.1713 87.5411 17.1713C85.4362 17.1713 83.6838 18.7907 83.6838 21.1675C83.6838 23.4057 85.4182 25.1625 87.7431 25.1625C89.623 25.1625 90.7079 24.0434 91.1542 23.3916L89.759 22.4839C89.2935 23.1485 88.6596 23.5889 87.7431 23.5889C86.8326 23.5889 86.1795 23.1814 85.761 22.3782L91.2348 20.167L91.0459 19.7125ZM85.4651 21.043C85.4182 19.5023 86.6907 18.7132 87.6024 18.7132C88.3168 18.7132 88.923 19.0619 89.1251 19.561L85.4651 21.043ZM81.016 24.9194H82.8154V13.1763H81.016V24.9194ZM78.0693 18.0614H78.0091C77.605 17.594 76.834 17.1713 75.8574 17.1713C73.8079 17.1713 71.934 18.9281 71.934 21.1804C71.934 23.4198 73.8079 25.1625 75.8574 25.1625C76.834 25.1625 77.605 24.7362 78.0091 24.2547H78.0693V24.8278C78.0693 26.3556 77.2333 27.1764 75.885 27.1764C74.7857 27.1764 74.1038 26.4014 73.8223 25.7496L72.2575 26.3873C72.7085 27.4465 73.9029 28.75 75.885 28.75C77.9947 28.75 79.7748 27.5381 79.7748 24.5894V17.4144H78.0693V18.0614ZM76.0113 23.5889C74.7713 23.5889 73.7333 22.5755 73.7333 21.1804C73.7333 19.7724 74.7713 18.7449 76.0113 18.7449C77.2334 18.7449 78.1968 19.7724 78.1968 21.1804C78.1968 22.5755 77.2334 23.5889 76.0113 23.5889ZM99.4701 13.1763H95.1666V24.9194H96.9611V20.4699H99.4701C101.463 20.4699 103.418 19.0619 103.418 16.8225C103.418 14.5843 101.458 13.1763 99.4701 13.1763ZM99.517 18.8365H96.9611V14.8097H99.517C100.857 14.8097 101.622 15.896 101.622 16.8225C101.622 17.7314 100.857 18.8365 99.517 18.8365ZM110.61 17.149C109.314 17.149 107.965 17.7079 107.411 18.9468L109.003 19.5986C109.346 18.9468 109.976 18.7355 110.643 18.7355C111.574 18.7355 112.518 19.2815 112.532 20.2456V20.3689C112.207 20.1857 111.512 19.9145 110.657 19.9145C108.942 19.9145 107.194 20.8363 107.194 22.5567C107.194 24.1303 108.599 25.1437 110.178 25.1437C111.386 25.1437 112.052 24.6117 112.471 23.9929H112.532V24.9006H114.265V20.3959C114.265 18.3139 112.673 17.149 110.61 17.149ZM110.394 23.5842C109.807 23.5842 108.989 23.3 108.989 22.5896C108.989 21.6806 110.009 21.3319 110.892 21.3319C111.682 21.3319 112.052 21.5021 112.532 21.7264C112.391 22.8139 111.433 23.5842 110.394 23.5842ZM120.58 17.4061L118.517 22.4968H118.456L116.323 17.4061H114.388L117.592 24.5201L115.764 28.4787H117.639L122.576 17.4061H120.58ZM104.404 24.9194H106.203V13.1763H104.404V24.9194Z"
        fill={palette.text.primary}
      />
      <defs>
        <linearGradient
          id="paint0_linear_3752_7131"
          x1="19.2446"
          y1="27.4202"
          x2="5.05731"
          y2="12.8891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3752_7131"
          x1="29.6675"
          y1="17.8715"
          x2="8.71061"
          y2="17.8715"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3752_7131"
          x1="21.8668"
          y1="15.9317"
          x2="2.62764"
          y2="-3.77365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3752_7131"
          x1="6.68429"
          y1="34.6363"
          x2="15.2754"
          y2="25.837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GooglePlayLogoSvg;
